import { SET_SELECTED_VARIANT } from '../constants/ActionTypes'

export default function setSelectedVariant(partNumber: string) {
    return {
        type: SET_SELECTED_VARIANT,
        payload: partNumber,
    }
}
